import React, { Component } from "react";
import * as contributorApi from "../../../api/contributorApi";
import { API_ROOT } from "../../../baseUrls";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { getMindfile, getCurrentUserMindfiles } from "../../../state/actions/getDataActions";
import _ from "lodash";
import ContentArea from "../../organisms/content-area/ContentArea";
import Box from "@material-ui/core/Box";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Button from "@material-ui/core/Button";
import TableContainer from "@material-ui/core/TableContainer";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import ContributorCard from "./ContributorCard";

class Contributors extends Component {
  constructor(props) {
    super(props);

    this.state = {
      searchUser: "",
      searchUserResults: [],
      emailInvite: "",
      isValidEmail: false,
    };

    this.debouncedHandleChangeSearchUser = _.debounce(username => {
      const searchUrl = new URL(`${API_ROOT}/mindfiles/search`);
      const queryParams = {
        "find_mindfile[name]": username,
        searcher_mindfile_id: this.props.mindfile.id,
        authenticity_token: this.props.user.authenticity_token,
      };
      Object.keys(queryParams).forEach(key =>
        searchUrl.searchParams.append(key, queryParams[key])
      );
      fetch(searchUrl, {
        method: "GET",
        credentials: "include",
      })
        .then(resp => resp.json())
        .then(searchUserResults => {
          this.setState({ searchUserResults });
        })
        .catch(error => console.error(error));
    }, 1000);
  }

  handleChangeSearchUser(evt) {
    const searchUser = evt.target.value;
    this.setState({ searchUser }, () => {
      this.debouncedHandleChangeSearchUser(searchUser);
    });
  }

  handleChangeEmailInvite(evt) {
    const emailInvite = evt.target.value;
    const isValidEmail = this.validateEmail(emailInvite);
    this.setState({ emailInvite, isValidEmail });
  }

  validateEmail(email) {
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  }

    inviteByMindfileId(inviteMindfileId) {
    return () => {
      const formData = new FormData();
      formData.append("invite_id", inviteMindfileId);
      // formData.append("authenticity_token", this.props.user.authenticity_token);

      fetch(`${API_ROOT}/mindfiles/${this.props.mindfile.id}/contributors`, {
        method: "POST",
        credentials: "include",
        body: formData,
        headers: {'X-CSRF-Token': this.props.user.authenticity_token},
      })
        .then(resp => resp.text())
        .then(() => this.props.getMindfile(this.props.mindfile.id));
    };
  }

  cancelInvitation(invitationId) {
    return () => {
      const formData = new FormData();
      formData.append("cancel_id", invitationId);
      // formData.append("authenticity_token", this.props.user.authenticity_token);

      fetch(`${API_ROOT}/mindfiles/${this.props.mindfile.id}/contributors`, {
        method: "POST",
        credentials: "include",
        body: formData,
        headers: {'X-CSRF-Token': this.props.user.authenticity_token},
      })
        .then(resp => resp.text())
        .then(() => this.props.getMindfile(this.props.mindfile.id));
    };
  }

  allowContributorRequest(requestId) {
    return () => {
      contributorApi
        .allowContributorRequest(this.props.mindfile.id, requestId, this.props.user.authenticity_token)
        .then(() => this.props.getMindfile(this.props.mindfile.id));
    };
  }

  denyContributorRequest(requestId) {
    return () => {
      contributorApi
        .denyContributorRequest(this.props.mindfile.id, requestId, this.props.user.authenticity_token)
        .then(() => this.props.getMindfile(this.props.mindfile.id));
    };
  }

  renderSearchUserResults() {
    if (!this.state.searchUserResults.length) {
      return null;
    }

    const tableRows = this.state.searchUserResults.map(item => {
      let locationString = "";
      if (item.location) {
        const locationArray = [
          item.location.locality,
          item.location.region,
          item.location.country,
        ];
        locationString = locationArray.filter(item => !!item).join(", ");
      }

      return (
        <TableRow key={item.id}>
          <TableCell>{item.name}</TableCell>
          <TableCell>{locationString}</TableCell>
          <TableCell>
            <Button
              variant="contained"
              color="primary"
              onClick={this.inviteByMindfileId(item.id).bind(this)}
            >
              Invite
            </Button>
          </TableCell>
        </TableRow>
      );
    });

    return (
      <TableContainer>
        <Table id="inviteTable">
          <TableBody>{tableRows}</TableBody>
        </Table>
      </TableContainer>
    );
  }

  renderContributors() {
    const contributors = this.props.mindfile.contributors || [];
    const tableRows = contributors.map(contributor => {
      return (
        <TableRow key={contributor.id}>
          <TableCell width="22">
            <img
              src={`${API_ROOT}/mindfiles/${contributor.user_mindfile_id}/avatar/thumbnail?size=96`}
              alt="avatar"
            />
          </TableCell>
          <TableCell>
            <ContributorCard
              user={this.props.user}
              mindfile={this.props.mindfile}
              contributor={contributor}
              authenticity_token={this.props.user.authenticity_token}
              isOwner={true}
            />
          </TableCell>
        </TableRow>
      );
    });

    return (
      <TableContainer>
        <Table id="contributorTable">
          <TableBody>{tableRows}</TableBody>
        </Table>
      </TableContainer>
    );
  }

  renderInvitationsSent() {
    const invitationsSent = this.props.mindfile.invitations_sent || [];
    const tableRows = invitationsSent.map(invitation => {
      return (
        <TableRow key={invitation.id}>
          <TableCell width="22">
            <img
              src={`${API_ROOT}/mindfiles/${invitation.user_mindfile_id}/avatar/thumbnail?size=96`}
              alt="avatar"
            />
          </TableCell>
          <TableCell>
            <Box display="inline-block" mr={2}>
              {invitation.name}
            </Box>
            <Box display="inline-block">
              <Button
                variant="contained"
                color="default"
                size="small"
                onClick={this.cancelInvitation(invitation.id).bind(this)}
              >
                Cancel
              </Button>
            </Box>
          </TableCell>
        </TableRow>
      );
    });

    if (tableRows.length) {
      return (
        <TableContainer>
          <Table id="sentTable">
            <TableBody>{tableRows}</TableBody>
          </Table>
        </TableContainer>
      );
    } else {
      return (
        <Typography>
          There are no pending invitations to contribute to this mindfile.
        </Typography>
      );
    }
  }

  renderContributorRequests() {
    const contributorRequests = this.props.mindfile.contributor_requests || [];
    const tableRows = contributorRequests.map(request => {
      return (
        <TableRow key={request.id}>
          <TableCell width="22">
            <img
              src={`${API_ROOT}/mindfiles/${request.user_mindfile_id}/avatar/thumbnail?size=96`}
              alt="avatar"
            />
          </TableCell>
          <TableCell>
            <Box display="inline-block" mr={2}>
              {request.name}
            </Box>
            <Box display="inline-block">
              <Button
                variant="contained"
                color="default"
                size="small"
                style={{ marginRight: 8 }}
                onClick={this.allowContributorRequest(request.id).bind(this)}
              >
                Allow
              </Button>
              <Button
                variant="contained"
                color="default"
                size="small"
                onClick={this.denyContributorRequest(request.id).bind(this)}
              >
                Deny
              </Button>
            </Box>
          </TableCell>
        </TableRow>
      );
    });

    if (tableRows.length) {
      return (
        <TableContainer>
          <Table id="requestsTable">
            <TableBody>{tableRows}</TableBody>
          </Table>
        </TableContainer>
      );
    } else {
      return (
        <Typography>
          There are no pending requests to contribute to this mindfile.
        </Typography>
      );
    }
  }

  render() {
    // const { classes } = this.props;
    return (
      <ContentArea>
        <div>
          <Card>
            <CardContent>
              <div style={{marginBottom: "1rem"}}>
                <Typography variant="h6">Contributors</Typography>
              </div>
              {this.renderContributors()}
            </CardContent>
          </Card>
        </div>

        <div style={{marginTop: "1rem"}}>
          <Card>
            <CardContent>
              <div style={{marginBottom: "1rem"}}>
                <Typography variant="h6">Requests</Typography>
              </div>
              {this.renderContributorRequests()}
            </CardContent>
          </Card>
        </div>

        <div style={{marginTop: "1rem"}}>
          <Card>
            <CardContent>
              <div style={{marginBottom: "1rem"}}>
                <Typography variant="h6">Invitations</Typography>
              </div>
              {this.renderInvitationsSent()}
            </CardContent>
          </Card>
        </div>

        <div style={{marginTop: "1rem"}}>
          <Card>
            <CardContent>
              <div style={{marginBottom: "1rem"}}>
                <Typography variant="h6">Send an Invitation</Typography>
              </div>
              <Typography>
                You can send an invitation to a fellow LifeNaut, or send an
                email to someone who isn't on LifeNaut yet.
              </Typography>
              <div>
                <TextField
                  label="LifeNaut name"
                  value={this.state.searchUser}
                  margin="dense"
                  size="small"
                  variant="outlined"
                  onChange={this.handleChangeSearchUser.bind(this)}
                />
              </div>
              {this.renderSearchUserResults()}
              <div>
                <TextField
                  label="Email"
                  value={this.state.emailInvite}
                  margin="dense"
                  size="small"
                  onChange={this.handleChangeEmailInvite.bind(this)}
                  variant="outlined"
                />
              </div>
              {this.state.isValidEmail ? (
                <Button variant="contained" color="primary">
                  Invite
                </Button>
              ) : null}
            </CardContent>
          </Card>
        </div>

        <div style={{marginTop: "1rem"}}>
          <Card>
            <CardContent>
              <div style={{marginBottom: "1rem"}}>
                <Typography variant="h6">Transfer Ownership</Typography>
              </div>
              <Typography>
                You can transfer ownership of this multi-user mindfile to
                another contributor. The new owner will have complete control of
                this mindfile. This change is PERMANENT and cannot be undone
                (except by the new owner transferring ownership back to you).
              </Typography>
              <div>
                <TextField
                  label="LifeNaut name"
                  value=""
                  margin="dense"
                  size="small"
                  variant="outlined"
                />
              </div>
            </CardContent>
          </Card>
        </div>
      </ContentArea>
    );
  }
}

const mapStateToProps = state => {
  return {
    user: state.auth,
    mindfile: state.mindfile,
  };
};

const mapDispatchToProps = {
  getMindfile,
  getCurrentUserMindfiles,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(Contributors));
